import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { AdminLayout } from "../layouts";
import { useAuth } from "../hooks";

const Auth               = lazy(() => import("../pages/admin/Auth/Auth").then((m) => ({ default: m.Auth })));
const Dashboard          = lazy(() => import("../pages/admin/Dashboard/Dashboard").then((m) => ({ default: m.Dashboard })));
const GestionHumana      = lazy(() => import("../pages/admin/GestionHumana/GestionHumana").then((m) => ({ default: m.GestionHumana })));
const GestionHumanaDetails = lazy(() => import("../pages/admin/GestionHumana/GestionHumanaDetails").then((m) => ({ default: m.GestionHumanaDetails })));
const Users              = lazy(() => import("../pages/admin/Users/Users").then((m) => ({ default: m.Users })));
const Settings           = lazy(() => import("../pages/admin/Settings/Settings").then((m) => ({ default: m.Settings })));
const PerfilesPuestoPage = lazy(() => import("../pages/admin/PerfilesPuesto/PerfilesPuestoPage").then((m) => ({ default: m.PerfilesPuestoPage })));
const CrearPerfilPage    = lazy(() => import("../pages/admin/PerfilesPuesto/CrearPerfilPage").then((m) => ({ default: m.CrearPerfilPage })));
const EditarPerfilPage   = lazy(() => import("../pages/admin/PerfilesPuesto/EditarPerfilPage").then((m) => ({ default: m.EditarPerfilPage })));
const VacantesPage       = lazy(() => import("../pages/admin/Vacantes/VacantesPage").then((m) => ({ default: m.VacantesPage })));
const TestimoniosPage    = lazy(() => import("../pages/admin/Testimonios/TestimoniosPage").then((m) => ({ default: m.TestimoniosPage })));
const PlantillasPage     = lazy(() => import("../pages/admin/Plantillas/PlantillasPage").then((m) => ({ default: m.PlantillasPage })));
const PerfilPage         = lazy(() => import("../pages/admin/Perfil/PerfilPage").then((m) => ({ default: m.PerfilPage })));
const SuscriptoresPage   = lazy(() => import("../pages/admin/Suscriptores/SuscriptoresPage").then((m) => ({ default: m.SuscriptoresPage })));
const NoticiasPage       = lazy(() => import("../pages/admin/Noticias/NoticiasPage").then((m) => ({ default: m.NoticiasPage })));
const ProductosAdminPage = lazy(() => import("../pages/admin/Productos/ProductosAdminPage").then((m) => ({ default: m.ProductosAdminPage })));
const SociosAdminPage    = lazy(() => import("../pages/admin/Socios/SociosAdminPage").then((m) => ({ default: m.SociosAdminPage })));
const CargarCvPage       = lazy(() => import("../pages/admin/CargarCv/CargarCvPage").then((m) => ({ default: m.CargarCvPage })));

const wrap = (Page) => <AdminLayout><Page /></AdminLayout>;

export function AdminRouter() {
  const { user } = useAuth();

  return (
    <Routes>
      {!user ? (
        <Route path="*" element={<Auth />} />
      ) : (
        <>
          <Route path="/"                          element={wrap(Dashboard)} />
          <Route path="/gestionhumana"             element={wrap(GestionHumana)} />
          <Route path="/gestionhumana/:id"         element={wrap(GestionHumanaDetails)} />
          <Route path="/users"                     element={wrap(Users)} />
          <Route path="/settings"                  element={wrap(Settings)} />
          <Route path="/perfiles-puesto"           element={wrap(PerfilesPuestoPage)} />
          <Route path="/perfiles-puesto/crear"     element={wrap(CrearPerfilPage)} />
          <Route path="/perfiles-puesto/:id/editar" element={wrap(EditarPerfilPage)} />
          <Route path="/vacantes"                  element={wrap(VacantesPage)} />
          <Route path="/testimonios"               element={wrap(TestimoniosPage)} />
          <Route path="/plantillas"                element={wrap(PlantillasPage)} />
          <Route path="/perfil"                    element={wrap(PerfilPage)} />
          <Route path="/suscriptores"              element={wrap(SuscriptoresPage)} />
          <Route path="/noticias"                  element={wrap(NoticiasPage)} />
          <Route path="/productos"                 element={wrap(ProductosAdminPage)} />
          <Route path="/socios"                    element={wrap(SociosAdminPage)} />
          <Route path="/cargar-cv"               element={wrap(CargarCvPage)} />
        </>
      )}
    </Routes>
  );
}
